import React from "react";
import { PrismicRichText } from "@prismicio/react";
import Slider from "react-slick";

const HeroCard = ({ cardSection }) => {

  const settings = {
    dots: true,
    arrows: false,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScoll: 1
  }

  return (
    <>
    {/* MOBILE CAROUSEL */}
      <div className="heroCardsContainer mobile">
        <Slider {...settings}>
          {cardSection?.map((card, index) => {

            const isValidRichText =
              Array.isArray(card.card_description) &&
              card.card_description.every(
                (block) =>
                  block &&
                  typeof block === "object" &&
                  "spans" in block &&
                  Array.isArray(block.spans)
              );

            const iconBorderColor =
              card.icon_border_color === "Gray" ? "#CCC" : "#00BCB4";

            return (
              <div key={index} className="p-4">
                <div className="heroCardWrapper">
                    {card.industry_card_icon?.url && (
                      <div  
                        className="heroCardIcon"
                        style={{ border: `20px solid ${iconBorderColor}` }}>
                          <img
                            src={card.industry_card_icon.url}
                            alt={card.industry_card_icon.alt || ""}
                          />
                      </div>
                    )}
                  {card.card_title?.[0]?.text && (
                    <h4 className="heroCardTitle">
                      {card.card_title[0].text}
                    </h4>
                  )}
                  {isValidRichText ? (
                    <PrismicRichText field={card.card_description} />
                  ) : (
                    <p>{card.card_description?.[0]?.text || ""}</p>
                  )}
                </div>
              </div>
            );
          })}
        </Slider>
      </div>

      {/* DESKTOP GRID */}
      <div 
        className="heroCardsContainer"
        style={{ gridTemplateColumns: `repeat(${cardSection?.length || 1}, 1fr)` }}
      >
        {cardSection?.length > 0 &&
          cardSection.map((card, index) => {

            const isValidRichText =
              Array.isArray(card.card_description) &&
              card.card_description.every(
                (block) =>
                  block &&
                  typeof block === "object" &&
                  "spans" in block &&
                  Array.isArray(block.spans)
              );

            let iconBorderColor = card.icon_border_color = "Gray" ? "#CCC" : "#00BCB4";

            const cardDividers = card.card_dividers ? "1px dotted #707070" : "none";

            return (
              <div className="heroCardWrapper" style={{ borderRight: cardDividers }} key={index}>
                {card.industry_card_icon?.url && (
                  <div      
                    className="heroCardIcon"
                    style={{ border: `20px solid ${iconBorderColor}` }}>
                    <img
                      src={card.industry_card_icon.url}
                      alt={card.industry_card_icon.alt || ""}
                    />
                  </div>
                )}
                {card.card_title?.[0]?.text && (
                  <h4 className="heroCardTitle">
                    {card.card_title[0].text}
                  </h4>
                )}
                {isValidRichText ? (
                  <PrismicRichText field={card.card_description} />
                ) : (
                  <p>{card.card_description?.[0]?.text || ""}</p>
                )}
              </div>
            );
          })}
      </div>
    </>
  );
};

export default HeroCard;
